import { Card, Divider, Grid, Tooltip } from "@mui/material";
import { BtnClear, BtnExportExcel, BtnSearch } from "components/Button/ButtonAll";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FnAxios, FnDialog } from "utilities/utilities";
import CheckIcon from '@mui/icons-material/Check';
import { GridColumnGroupingModel } from '@mui/x-data-grid';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import IconButton from '@mui/material/IconButton';
import DialogPreview from "components/DialogPreview/DialogPreview";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadIcon from "@mui/icons-material/Download";
import { EnumMasterData } from "enum/enum";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import moment from "moment";

export default function PerformanceReport(props: { sMode }) {
    const arrPin = ['nNo', 'sPosition', 'sFullName'];
    const { sMode } = props;
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataReport, setDataReport] = useState<any>([]);
    const [sHeadName, setHeadName] = useState("");
    const [arrChildren, setArrChildren] = useState<any>([]);
    const [lstRawReport, setLstRawReport] = useState([]);
    const [arrReport, setarrReport] = useState([]);
    const [lstUser, setLstUser] = useState([]);
    const [loadingTableRemark, setLoadingTableRemark] = useState(false);
    const [isOpenRemarkModal, setOpenRemarkModal] = useState(false);

    const [sDocName, setDocName] = useState([]);
    const [isOpenFile, setIsOpenFile] = useState(false);
    const [arrModalFile, setArrModalFile] = useState([]);
    const [sEmpTypeID, setEmpTypeID] = useState("");
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "nPositionOrder",
        sSortDirection: "asc"
    });
    const [dataRowRemark, setDataRowRemark] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sWorkDate",
        sSortDirection: "asc"
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            dYearPickerSeach: moment(),
            dMonthPickerSeach: moment(),
        } as any,
    });

    const dataRawReport: any = [
        {
            field: 'nNo',
            headerName: 'ลำดับ',
            headerAlign: 'center',
            width: 40,
            sortable: true,
            align: "center",
        },
        {
            field: 'sPosition',
            headerName: 'ตำแหน่ง',
            headerAlign: 'center',
            minWidth: 250,
            sortable: true,
            align: "left",
        },
        {
            field: 'sFullName',
            headerName: 'ชื่อ - นามสกุล',
            headerAlign: 'center',
            minWidth: 240,
            sortable: true,
            align: "Left",
        }
    ];

    //merge tabel head
    const columnGroupingModel: GridColumnGroupingModel = [
        {
            groupId: "sMonth",
            headerName: sHeadName,
            description: "",
            children: arrChildren,
            headerAlign: "center",
        },
        {
            groupId: "sGroupLeaveType",
            headerName: "รวม (จำนวนวัน)",
            description: "",
            children: [{ field: "nCountSick" }, { field: "nCountLeave" }, { field: "nCountAbsent" }, { field: "nCountLate" }, { field: "nCountDuty", }],
            headerAlign: "center",
        },
    ];

    //remark table
    const dataRawReportRemark: any = [
        {
            field: 'sWorkDate',
            headerName: 'วันปฎิบัติงาน',
            headerAlign: 'center',
            width: 100,
            sortable: true,
            align: "center",
        },
        {
            field: 'sStartWorkTime',
            headerName: 'เวลาเข้า',
            headerAlign: 'center',
            minWidth: 100,
            sortable: true,
            align: "center",
        },
        {
            field: 'sEndWorkTime',
            headerName: 'เวลาออก',
            headerAlign: 'center',
            minWidth: 100,
            sortable: true,
            align: "center",
        },
        {
            field: 'sRemark',
            headerName: 'หมายเหตุ',
            headerAlign: 'center',
            minWidth: 250,
            sortable: true,
            align: "center",
        },
        {
            field: 'objFile',
            headerName: 'ไฟล์แนบ',
            headerAlign: 'center',
            minWidth: 100,
            sortable: true,
            align: "center",
            renderCell: (item) => {
                return (
                    item.row.sFilePath != undefined && item.row.sFilePath !== "" ?
                        <IconButton size="small" onClick={() => handleViewFile(item.row)}>
                            <InsertDriveFileIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                        :
                        null
                );
            }
        }
    ];

    const getFormInitial = () => {
        let param = {
            sEmpTypeID: sMode
        }

        AxiosFn.Post(`OperationalReport/GetFormInitialReport`, param, (result) => {
            setLstUser(result.objResult.lstUserOnTypeTwo);
        });
    }

    const getTable = (p: PaginationInterface) => {
        setLoadingTable(true);
        const ObjForm = form.getValues();
        const nSetYear = ObjForm.dYearPickerSeach === null ? moment().year() : moment(ObjForm.dYearPickerSeach).year();
        const nSetMonth = ObjForm.dMonthPickerSeach === null ? moment().month() + 1 : moment(ObjForm.dMonthPickerSeach).month() + 1;

        let param = {
            ...p,
            sEmpTypeID: sMode,
            lstUser: ObjForm.lstUser || [],
            nYear: nSetYear,
            nMonth: nSetMonth,
        }

        AxiosFn.Post(`OperationalReport/GetTable`, param, (result) => {
            setLoadingTable(false);

            setarrReport(result.objResult.lstDate);
            setLstRawReport(result.objResult.lstRawReport);
            setDataRow({
                ...p,
                arrRows: result.lstReport,
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        });
    };

    const handleExportExcel = () => {
        DialogFn.BlockUI();
        let sFileName = `บัญชีการปฏิบัติงาน.xlsx`
        const ObjForm = form.getValues();
        const nSetYear = ObjForm.dYearPickerSeach ? moment(ObjForm.dYearPickerSeach).valueOf() : null;
        const nSetMonth = ObjForm.dMonthPickerSeach ? moment(ObjForm.dMonthPickerSeach).valueOf() + 1 : null;
        let param = {
            lstRawReport: lstRawReport, //dataRow.arrRows,
            lstDate: arrReport,
            lstUser: ObjForm.lstUser || [],
            nYear: nSetYear,
            nMonth: nSetMonth,
        }

        AxiosFn.DowloadFileBlob(`OperationalReport/onExportOperationExcel`, param, sFileName, (result) => {
            DialogFn.UnBlockUI();
        });
    }

    const getTableRemark = (p: PaginationInterface, sUserID?: string, nAttendanceID?: number) => {
        setLoadingTableRemark(true);
        const ObjForm = form.getValues();
        const nSetYear = ObjForm.dYearPickerSeach === null ? moment().year() : moment(ObjForm.dYearPickerSeach).year();
        const nSetMonth = ObjForm.dMonthPickerSeach === null ? moment().month() + 1 : moment(ObjForm.dMonthPickerSeach).month() + 1;

        let param = {
            ...p,
            sUserID: sUserID,
            nAttendanceID: nAttendanceID,
            nYear: nSetYear,
            nMonth: nSetMonth,
        }

        AxiosFn.Post(`OperationalReport/GetTableRemarkOperation`, param, (result) => {
            setLoadingTableRemark(false);
            setOpenRemarkModal(true);

            setDataRowRemark({
                ...p,
                arrRows: result.lstReportReportRemark ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        });
    };

    const handleViewFile = (objRow) => {
        let param = {
            nAttendanceID: objRow.nAttendanceID
        }
        setDocName(objRow.sTitle);
        AxiosFn.Post(`OperationalReport/GetReportPDF`, param, (result) => {
            DialogFn.UnBlockUI();
            setIsOpenFile(true);
            setArrModalFile(result.lstFilePDF);
        });
    };

    const handleClearFilter = () => {
        form.setValue("lstUser", []);
        form.setValue("dYearPickerSeach", null);
        form.setValue("dMonthPickerSeach", null);

        form.clearErrors("lstUser");
        form.clearErrors("dYearPickerSeach");
        form.clearErrors("dMonthPickerSeach");
    }

    useEffect(() => {
        const dataColumn = [...dataRawReport,
        //month column
        ...arrReport.map((o) => {
            setHeadName(o.label);
            return {
                field: "Date_" + o.value,
                headerName: o.value,
                headerAlign: 'center',
                width: 50,
                sortable: false,
                cellClassName: o.sValue === "Y" ? 'holiday-bg' : "",
                align: "center",
                renderCell: (item) => {
                    const itemData = item.row.lstReportPerMonth.find(s => s.sMonthName === o.label && +(s.sWorkDay) === o.value);
                    const isHaveType = itemData != null;
                    return (
                        isHaveType ?
                            itemData.nStatusAbbr !== EnumMasterData.NormalWork ?
                                <Tooltip title={itemData.sStatuNameFull}>
                                    <span style={{ color: ((itemData.nStatusAbbr === EnumMasterData.Absent|| itemData.nStatusAbbr === EnumMasterData.HalfAbsent) ? "red" : "#DA0000 !important") }}>
                                        {itemData.sStatusAbbr}
                                    </span>
                                </Tooltip>
                                :
                                <Tooltip title={itemData.sStatuNameFull}>
                                    {itemData.sStatusAbbr ?? <CheckIcon />}
                                </Tooltip>
                            :
                            null
                    );
                }
            }
        }),
        //ลาป่วย
        {
            field: "nCountSick",
            headerName: "ลาป่วย",
            headerAlign: 'center',
            width: 75,
            sortable: false,
            align: "center",
            renderCell: (item) => {
                return (
                    <div>
                        {item.row.nCountSick !== 0 ? item.row.nCountSick : null}
                    </div>
                );
            }
        },
        //ลา
        {
            field: "nCountLeave",
            headerName: "ลา",
            headerAlign: 'center',
            width: 75,
            sortable: false,
            align: "center",
            renderCell: (item) => {
                return (
                    <div>
                        {item.row.nCountLeave !== 0 ? item.row.nCountLeave : null}
                    </div>
                );
            }
        },
        //ขาด
        {
            field: "nCountAbsent",
            headerName: "ขาด",
            headerAlign: 'center',
            width: 75,
            sortable: false,
            align: "center",
            renderCell: (item) => {
                return (
                    <div>
                        {item.row.nCountAbsent !== 0 ? item.row.nCountAbsent : null}
                    </div>
                );
            }
        },
        //สาย
        {
            field: "nCountLate",
            headerName: "สาย",
            headerAlign: 'center',
            width: 75,
            sortable: false,
            align: "center",
            renderCell: (item) => {
                return (
                    <div>
                        {item.row.nCountLate !== 0 ? item.row.nCountLate : null}
                    </div>
                );
            }
        },
        //ไปราชการ
        {
            field: "nCountDuty",
            headerName: "ไปราชการ",
            headerAlign: 'center',
            width: 75,
            sortable: false,
            align: "center",
            renderCell: (item) => {
                return (
                    <div>
                        {item.row.nCountDuty !== 0 ? item.row.nCountDuty : null}
                    </div>
                );
            }
        },
        //remark column
        {
            field: "sRemark",
            headerName: "หมายเหตุ",
            headerAlign: 'center',
            width: 80,
            sortable: true,
            align: "center",
            renderCell: (item) => {
                return (
                    item.row.isRemark || item.row.isFile ?
                        <IconButton color="primary" aria-label="add to shopping cart" onClick={() => getTableRemark(dataRowRemark, item.row.sUserID, item.row.nAttendanceID)}>
                            <AnnouncementIcon />
                        </IconButton>
                        : null
                );
            }
        },
        ];
        setDataReport(dataColumn)

        let arrChildren = [];
        dataColumn.forEach(f => {
            if (f.field.includes("Date_")) {
                arrChildren.push({ field: f.field })
            }
        });

        setArrChildren(arrChildren);
    }, [arrReport]);

    useEffect(() => {
        getFormInitial();
        getTable(dataRow);
    }, [])

    return (
        <FormProvider {...form}>
            <Grid container>
                {/* filter */}
                <Grid item xs={12} md={12} container spacing={1} justifyItems={'flex-start'} justifyContent={'flex-end'} sx={{ mt: "2%" }}>
                    <Grid item xs={12} md={10} container spacing={2} justifyItems={'flex-start'} justifyContent={'end'}>
                        <Grid item xs={12} md={4.5}>
                            <MultipleSelectItem
                                id={"lstUser"}
                                name={"lstUser"}
                                label={"ชื่อ - นามสกุล"}
                                required={false}
                                options={lstUser}
                                limitTag={1}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <DatePickerItem
                                name={`dYearPickerSeach`}
                                id={`dYearPickerSeach`}
                                label={"ปี"}
                                IsYearPicker
                                required={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <DatePickerItem
                                name={`dMonthPickerSeach`}
                                id={`dMonthPickerSeach`}
                                label={"เดือน"}
                                IsMonthPicker
                                required={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={1.5} container spacing={1} justifyItems={'flex-start'} justifyContent={'end'}>
                            <Grid item>
                                <BtnClear id={'btnClearSearchAll'} IsCircleWithOutText={true} onClick={() => { handleClearFilter(); }} />
                            </Grid>
                            <Grid item>
                                <BtnSearch id={'btnSearchAll'} IsCircleWithOutText={true}
                                    onClick={() => { getTable(dataRow); }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={2} justifyContent={"flex-end"} sx={{ display: "flex" }}>
                        <BtnExportExcel id={"expOptionalReport"} tooltiptxt='Export to Excel File' onClick={() => { handleExportExcel() }} />
                    </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: "2%" }}>
                    <DataGrid
                        sTableID={`tableReport_${sEmpTypeID}`}
                        columns={dataReport}
                        rows={dataRow}
                        isLoading={loadingTable}
                        onLoadData={getTable}
                        isShowCheckBox={false}
                        experimentalFeatures={{ columnGrouping: true }}
                        columnGroupingModel={columnGroupingModel}
                        isHiddenToolHead
                        isPin={false}
                        isDisableColumnMenu
                        arrPin={arrPin}
                    />
                </Grid>

                {/* remark */}
                <DialogPreview
                    IsOpen={isOpenRemarkModal}
                    IsBackdropClick={false}
                    onClose={() => setOpenRemarkModal(prev => !prev)}
                    JsxDialogAction
                    CloseSave={false}
                    Close={false}
                    sMaxWidth='sm'
                    bgColor={"#a07300"}
                    Color='white'
                    Title={'หมายเหตุ/ไฟล์แนบ'}
                >
                    <Grid item xs={12} sx={{ mt: "2%" }}>
                        <DataGrid
                            sTableID={`tableOperation_${sMode}`}
                            columns={dataRawReportRemark}
                            rows={dataRowRemark}
                            isLoading={loadingTableRemark}
                            onLoadData={getTableRemark}
                            isShowCheckBox={false}
                            isHiddenFooter
                            isHiddenToolHead
                            isPin={false}
                        />
                    </Grid>
                </DialogPreview>

                {/* File */}
                <DialogPreview
                    IsOpen={isOpenFile}
                    IsBackdropClick={false}
                    onClose={() => setIsOpenFile(prev => !prev)}
                    JsxDialogAction
                    CloseSave={false}
                    Close={false}
                    sMaxWidth='sm'
                    bgColor={"#a07300"}
                    Color='white'
                    Title={'หมายเหตุ/ไฟล์แนบ'}
                >
                    <Grid item xs={12}>
                        <Card sx={{ padding: 2 }}>
                            {arrModalFile.length > 0 && arrModalFile.map((m) => (
                                <Grid key={m.sFilePath} container mt={1}>
                                    <Grid item xs={12}>
                                        <a
                                            href={
                                                process.env.REACT_APP_API_URL +
                                                "UploadFile/" +
                                                m.sFilePath
                                            }
                                            download
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                container
                                                justifyContent={"space-between"}
                                            >
                                                <Grid item key={m.sFileName}>
                                                    {m.sFileName}
                                                </Grid>
                                                <Grid item key={m.sFileName}>
                                                    <IconButton size="small">
                                                        <DownloadIcon color={"primary"} />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </a>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </Card>
                    </Grid>
                </DialogPreview>
            </Grid>
        </FormProvider>
    );
}